import { GridResourceStringsEN } from 'igniteui-angular';
import { GridResourceStringsDE } from 'igniteui-angular-i18n/i18n/DE/grid-resources.js';
import { GridResourceStringsFR } from 'igniteui-angular-i18n/i18n/FR/grid-resources.js';
import { GridResourceStringsIT } from 'igniteui-angular-i18n/i18n/IT/grid-resources.js';

export class GridResources {
    static English = GridResourceStringsEN;
    static German = GridResourceStringsDE;
    static Italian = GridResourceStringsIT;
    static French = GridResourceStringsFR;
}
